import { aesDecrypt, aesEncrypt } from "crypt-hpulido";
import { env } from "./Environment";
import { Theme, ToastPosition, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as DomicilappService from "../services/DomicilappService";

import { UsersItems } from "../models/Users";
import md5 from "md5";
import Fingerprint2 from 'fingerprintjs2';

// type messagesItems = {
//   [key: string]: {
//     en: string;
//     es: string;
//   };
// };

const messages = require("../config/messages.json");

export async function encrypt(text_plain: string) {
  const crypt_key = await env("KEY_AES_ENCRYPT");
  return aesEncrypt(text_plain, crypt_key)
    .then((crypt) => {
      return crypt;
    })
    .catch((error) => {
      console.error("Hubo un error:", error);
      return "";
    });
}

export async function decrypt(text_crypt: string) {
  const crypt_key = await env("KEY_AES_ENCRYPT");
  return aesDecrypt(text_crypt, crypt_key);
}

export async function encryptList(list: Object) {
  const listEncrypt: { [key: string]: string } = {};

  for (const key of Object.keys(list) as (keyof typeof list)[]) {
    try {
      const encryptedValue = await encrypt(list[key] + "");
      listEncrypt[key] = encryptedValue;
    } catch (error) {
      console.error("Error encriptando el valor:", error);
    }
  }
  return listEncrypt;
}

export const customMessage = (key: string) => {
  return messages[key]["es"];
}

export function showToastTR(
  message: string,
  timeout: number,
  type = "default"
) {
  showToast(message, "top-right", timeout, type);
}

export function showToastTC(
  message: string,
  timeout: number,
  type = "default"
) {
  showToast(message, "top-center", timeout, type);
}

function showToast(
  message: string,
  position: ToastPosition,
  timeout: number,
  type: string
) {
  const toastOptions = {
    position: position,
    autoClose: timeout,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: getTheme(),
  };

  switch (type) {
    case "warn":
      toast.warn(message, toastOptions);
      break;
    case "info":
      toast.info(message, toastOptions);
      break;
    case "success":
      toast.success(message, toastOptions);
      break;
    case "error":
      toast.error(message, toastOptions);
      break;
    default:
      toast(message, toastOptions);
      break;
  }
}

function getTheme(): Theme {
  // Incialmente se deja light
  return "light";
}

export async function getCurrentUser(): Promise<UsersItems | null> {

  const response = await DomicilappService.getCurrentUser();
  console.log(response)
  if (response !== null) {
    if (response.status === 200) {
      if (response.data) {
        return response.data;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }

}

export async function getDeviceId() {
  const fp = await new Promise((resolve, reject) => {
    Fingerprint2.get((components: any) => {
      const values = components.map((component: any) => component.value);
      const murmur = Fingerprint2.x64hash128(values.join(''), 21);
      resolve(murmur);
    });
  });
  return fp + md5(fp + "")
};

export async function getDeviceData() {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const language = window.navigator.language;
  const resolution = `${window.screen.width}x${window.screen.height}`;

  let os: string;
  let device_id: string;
  let browser: string;
  let browser_version: string | undefined;

  if (/Android/i.test(userAgent)) {
    os = 'Android';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    os = 'iOS';
  } else if (/Win/i.test(platform)) {
    os = 'Windows';
  } else if (/Mac/i.test(platform)) {
    os = 'MacOS';
  } else if (/Linux/i.test(platform)) {
    os = 'Linux';
  } else {
    os = 'Desconocido';
  }

  if (/Firefox/i.test(userAgent)) {
    browser = 'Firefox';
    browser_version = /Firefox\/([\d.]+)/i.exec(userAgent)?.[1];
  } else if (/Chrome/i.test(userAgent)) {
    browser = 'Chrome';
    browser_version = /Chrome\/([\d.]+)/i.exec(userAgent)?.[1];
  } else if (/Safari/i.test(userAgent)) {
    browser = 'Safari';
    browser_version = /Version\/([\d.]+)/i.exec(userAgent)?.[1];
  } else if (/Edge/i.test(userAgent)) {
    browser = 'Edge';
    browser_version = /Edge\/([\d.]+)/i.exec(userAgent)?.[1];
  } else if (/Opera|OPR/i.test(userAgent)) {
    browser = 'Opera';
    browser_version = /(?:Opera|OPR)\/([\d.]+)/i.exec(userAgent)?.[1];
  } else if (/FxiOS/i.test(userAgent)) {
    browser = 'Firefox iOS';
    browser_version = /FxiOS\/([\d.]+)/i.exec(userAgent)?.[1];
  } else if (/CriOS/i.test(userAgent)) {
    browser = 'Chrome iOS';
    browser_version = /CriOS\/([\d.]+)/i.exec(userAgent)?.[1];
  } else {
    browser = 'Desconocido';
  }

  device_id = await getDeviceId()
  return { device_id, os, browser, browser_version, language, resolution };
}


// export async function getCustomRanges() {

//   const customRanges = {
//     Today: [new Date(), new Date()],
//     Yesterday: [
//       new Date(new Date().setDate(new Date().getDate() - 1)),
//       new Date(new Date().setDate(new Date().getDate() - 1)),
//     ],
//     'Last 7 Days': [new Date(new Date().setDate(new Date().getDate() - 6)), new Date(new Date())],
//     'Last 30 Days': [new Date(new Date().setDate(new Date().getDate() - 29)), new Date(new Date())],
//     'This Month': [
//       new Date(new Date().setDate(1)),
//       new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
//     ],
//     'Last Month': [
//       new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
//       new Date(new Date().getFullYear(), new Date().getMonth(), 0),
//     ],
//   }
//   return customRanges;
// }


// export function validateUrl(url: string) {
//   const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
//   return urlRegex.test(url);
// };

export function validateUrl(input: string): boolean {
  // Expresión regular más estricta para validar URLs completas
  const urlRegex = /^(ftp|http|https):\/\/(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9]+)+)(?:\/[\w-]+)*(?:\?[\w%&=]*)?(?:#[\w-]*)?$/;
  return urlRegex.test(input);
};


